/**
 * Root to walk when reading an embedder `<template>`'s markup.
 *
 * The HTML parser puts template children into `el.content`. React (18/19) and
 * other non-parser DOM builders instead append JSX children to the `<template>`
 * host (`el.childNodes`), leaving `.content` empty — see
 * https://github.com/facebook/react/issues/19932. Structural discovery and
 * scoped-style injection both need to see either shape.
 *
 * Preference:
 *  1. `el.content` when it has any child nodes (native HTML / innerHTML path)
 *  2. else `el` itself when the host has children (React JSX path)
 *  3. else empty `el.content`
 *
 * Read-only: never moves live nodes into `.content` (React still owns host
 * children; stealing them would break re-renders / StrictMode).
 */
export const templateParseRoot = (
  el: HTMLTemplateElement,
): DocumentFragment | HTMLTemplateElement => {
  if (el.content.childNodes.length > 0) return el.content;
  if (el.childNodes.length > 0) return el;
  return el.content;
};
